var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gridicons:phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6667 1.33325H5.33333C4.97971 1.33325 4.64057 1.47373 4.39052 1.72378C4.14048 1.97382 4 2.31296 4 2.66659V13.3333C4 13.6869 4.14048 14.026 4.39052 14.2761C4.64057 14.5261 4.97971 14.6666 5.33333 14.6666H10.6667C11.0203 14.6666 11.3594 14.5261 11.6095 14.2761C11.8595 14.026 12 13.6869 12 13.3333V2.66659C12 2.31296 11.8595 1.97382 11.6095 1.72378C11.3594 1.47373 11.0203 1.33325 10.6667 1.33325ZM8.66667 13.9999H7.33333V13.3333H8.66667V13.9999ZM10.6667 12.6666H5.33333V3.33325H10.6667V12.6666Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.4c8d870c9f9eb02cab026462c4156805.svg";
export { ForwardRef as ReactComponent };